import { createRoot } from 'react-dom/client'
import { CssVarsProvider } from '@mui/joy'
import { Provider as JotaiProvider } from 'jotai'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { theme } from '../theme'
import axios from 'axios'
import CssBaseline from '@mui/joy/CssBaseline'
import { RouterProvider } from 'react-router-dom'

import '../i18n'
import { API_KEY, API_VERSION } from '../constants'
import router from '@/router'
import { getWebAppRoot } from '@/web-app-root'

const queryClient = new QueryClient()

axios.defaults.headers.common['x-api-key'] = API_KEY
axios.defaults.headers.common['x-api-version'] = API_VERSION

function WebApp() {
    return (
        <JotaiProvider>
            <CssVarsProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <CssBaseline />
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </CssVarsProvider>
        </JotaiProvider>
    )
}

const domNode = getWebAppRoot()

if (!domNode) throw new Error('Missing #react-web-app-root root')

const root = createRoot(domNode)

root.render(<WebApp />)
